import type { ConfigurationResponse } from '../types';
import { flattenAttributes } from './flattenAttributes';
import { getDebugInfo } from './getDebugInfo';
import { AttributeValue, getMetricAttributes } from './getMetricAttributes';
import { parseUserAgent } from './parseUserAgent';

export const getExtensionOpenedAttributes = (
  config?: ConfigurationResponse['data'],
): Record<string, AttributeValue> => {
  const debugInfo = getDebugInfo({ config });
  const { browser, os } = parseUserAgent(debugInfo.navigator.userAgent);

  return {
    ...getMetricAttributes(config),
    ...flattenAttributes({
      'outlook.email': debugInfo.outlook.email,
      'outlook.isSharedMailbox': debugInfo.outlook.isSharedMailbox,
      'outlook.naaSupported': debugInfo.outlook.naaSupported,
      'outlook.ssoSupported': debugInfo.outlook.ssoSupported,
      'outlook.highestMailboxRequirementSet': debugInfo.outlook.highestMailboxRequirementSet,
      'outlook.displayLanguage': debugInfo.outlook.displayLanguage,
      'config.v2': debugInfo.config?.v2,
      'config.secure-before-you-click': debugInfo.config?.['secure-before-you-click'],
      'config.test-safely': debugInfo.config?.['test-safely'],
      'config.unzim-outbound-emails': debugInfo.config?.['unzim-outbound-emails'],
      'config.notification-preference': debugInfo.config?.['notification-preference'],
      'navigator.language': debugInfo.navigator.language,
      'navigator.route': debugInfo.navigator.route,
      'navigator.browser': browser,
      'navigator.os': os,
    }),
  };
};
